module.exports = function() {
  return new Worker(__webpack_public_path__ + "88fcadc3d0b64543015e.worker.js");
};